import PropTypes from "prop-types";
import { DashedLine } from "@pageComponents/best-in-travel-2025/dashedLine";

const makeKey = str => str.slice(0, 16);

export function OL({ data }) {
  return (
    <div className="px-6 pb-8 lg:px-12">
      <h3 className="mb-6 text-2xl font-normal font-neue">
        Highlight{data.length > 1 && "s"}
      </h3>
      <ol>
        {data.map((item, i) => (
          <li key={makeKey(item)} className="flex flex-col">
            <div className="flex">
              <p className="flex-none w-12 text-4xl font-bold leading-tight font-rama text-blue">
                0{i + 1}
              </p>
              <p className="text-slate">{item}</p>
            </div>
            {i + 1 !== data.length && (
              <DashedLine className="w-full my-4 text-center text-itinerary-blue-200" />
            )}
          </li>
        ))}
      </ol>
    </div>
  );
}

OL.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string).isRequired,
};
